// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"685":"d0821096","951":"a2a67324"}[chunkId] + ".chunk.js";
};